import React from "react";

export const years = Array.from({ length: 50 }, (_, i) =>
  (new Date().getFullYear() - i).toString()
);

export const makes = [
  "Toyota",
  "Honda",
  "Ford",
  "Chevrolet",
  "BMW",
  "Mercedes-Benz",
  "Nissan",
  "Subaru",
  "Volkswagen",
  "Hyundai",
  "Kia",
  "Other"
];

// Basic model mapping - could be expanded or fetched dynamically
export const modelsByMake = {
  Toyota: [
    "Camry",
    "Corolla",
    "RAV4",
    "Tacoma",
    "Highlander",
    "Sienna",
    "Other Models"
  ],
  Honda: [
    "Civic",
    "Accord",
    "CR-V",
    "Pilot",
    "Odyssey",
    "HR-V",
    "Other Models"
  ],
  Ford: [
    "F-150",
    "Explorer",
    "Escape",
    "Mustang",
    "Edge",
    "Bronco",
    "Other Models"
  ],
  Chevrolet: [
    "Silverado",
    "Equinox",
    "Traverse",
    "Malibu",
    "Tahoe",
    "Camaro",
    "Other Models"
  ],
  BMW: ["3 Series", "5 Series", "X3", "X5", "X1", "X7", "Other Models"],
  "Mercedes-Benz": [
    "C-Class",
    "E-Class",
    "GLC",
    "GLE",
    "A-Class",
    "S-Class",
    "Other Models"
  ],
  Nissan: [
    "Altima",
    "Rogue",
    "Sentra",
    "Pathfinder",
    "Murano",
    "Maxima",
    "Other Models"
  ],
  Subaru: [
    "Outback",
    "Forester",
    "Crosstrek",
    "Ascent",
    "Impreza",
    "WRX",
    "Other Models"
  ],
  Volkswagen: [
    "Jetta",
    "Tiguan",
    "Atlas",
    "Passat",
    "Golf",
    "Taos",
    "Other Models"
  ],
  Hyundai: [
    "Elantra",
    "Tucson",
    "Santa Fe",
    "Sonata",
    "Kona",
    "Palisade",
    "Other Models"
  ],
  Kia: [
    "Sportage",
    "Sorento",
    "Telluride",
    "Forte",
    "Optima/K5",
    "Soul",
    "Other Models"
  ],
  Other: ["Other Models"]
};

export const partCategories = [
  "Transmission",
  "Body & Exterior",
  "Interior",
  "Lighting",
  "Suspension & Steering",
  "Steering",
  "Brakes",
  "Wheels & Tires",
  "Interior",
  "Exhaust",
  "Cooling & A/C",
  "Wheels & Tires",
  "Cooling & Heating",
  "Fuel & Exhaust",
  "Filters & Fluids",
  "Miscellaneous"
];

export const partsByPartCategory = {
  Transmission: [
    "Complete Transmission",
    "Clutch Kit",
    "Flywheel",
    "Torque Converter",
    "Transmission Filter",
    "Gear Set"
  ],
  "Body & Exterior": [
    "Bumper (Front)",
    "Bumper (Rear)",
    "Fender (Left)",
    "Fender (Right)",
    "Hood",
    "Mirror",
    "Grille",
    "Trunk / Tailgate",
    "Door (Front, Left)",
    "Door (Front, Right)",
    "Door (Rear, Left)",
    "Door (Rear, Right)",
    "Grille"
  ],
  Lighting: [
    "Headlight (Left)",
    "Headlight (Right)",
    "Taillight (Left)",
    "Taillight (Right)",
    "Fog Light",
    "Brake Light (Third)"
  ],
  "Suspension & Steering": [
    "Shock/Strut Assembly",
    "Control Arm",
    "Sway Bar",
    "Coil Spring",
    "Leaf Spring",
    "Axle Assembly"
  ],
  Steering: [
    "Steering Rack",
    "Power Steering Pump",
    "Tie Rod End",
    "Steering Wheel"
  ],
  Brakes: [
    "Brake Caliper",
    "Brake Rotor/Disc",
    "Brake Master Cylinder",
    "ABS Control Module",
    "Brake Booster"
  ],
  "Wheels & Tires": [
    "Wheel/Rim",
    "Set of Wheels",
    "Tire",
    "Set of Tires",
    "Spare Tire"
  ],
  Interior: [
    "Seat (Front Driver)",
    "Seat (Front Passenger)",
    "Rear Seat Assembly",
    "Dashboard Assembly",
    "Center Console",
    "Radio/Head Unit",
    "Instrument Cluster",
    "Door Panel"
  ],
  Exhaust: [
    "Muffler",
    "Catalytic Converter",
    "Exhaust Manifold",
    "Exhaust Pipe"
  ],
  "Cooling & Heating": [
    "Radiator",
    "A/C Compressor",
    "Condenser",
    "Heater Core",
    "Cooling Fan Assembly"
  ],
  "Fuel & Exhaust": [
    "Fuel Pump",
    "Fuel Tank",
    "Fuel Injector",
    "Throttle Body"
  ],
  "Filters & Fluids": ["Air Filter Box", "Washer Fluid Reservoir"]
};
